export const Props = () => ({
  //Данные уведомления
  data: { type: Object },

  //Это системное уведомление?
  isSystemMessage: { type: Boolean },
});